import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-campaign-step-number',
  templateUrl: './campaign-step-number.component.html',
  styleUrl: './campaign-step-number.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full flex-col items-center gap-1' },
  imports: [NgCommonModule],
})
export class CampaignStepNumberComponent {
  active = input<boolean>(false);
  first = input<boolean>(false);
  last = input<boolean>(false);
}
